import { Project } from "@brg/api";
import { Colors, FlexBox } from "@brg/ui";
import { FC, useMemo } from "react";
import styled, { css } from "styled-components";
import { DEFAULT_VIEW_TYPE, ProjectBottomActionsWrapper } from "./ps-bottom-actions";
import { LayoutConst } from "core";
import { useTranslation } from "react-i18next";
import { FlorinIcon } from "shared/icons/FlorinIcon/FlorinIcon";
import { ModerationType } from "../../teams/const/ModerationTypes";

export const ProtectWrapper = styled(ProjectBottomActionsWrapper)<{ longreadCount?: number}>`
    text-align: center;
    min-height: 145px;
    max-height: 145px;
    display: flex;
    flex-flow: column;
    margin: 24px auto;
`;

export const ProtectTitle = styled(FlexBox)`
    color: ${Colors.zel};
    font-weight: 600;
    font-family: 'Inter', Sans-serif;
    font-size: 30px;
    line-height: 40px;
    margin-bottom: 12px;

    @media (max-width: ${LayoutConst.screen.mac13 + 1}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
        font-size: 23px;
        line-height: 29px;
    }

    @media(max-width: ${LayoutConst.screen.s -1}px) {
        font-size: 22px;
        line-height: 28px;
    }
`;

export const ProtectSubtitle = styled(FlexBox)`
    color: ${Colors.zel};
    font-weight: 400;
    font-family: 'Inter', Sans-serif;
    font-size: 17px;
    line-height: 22px;

    margin-bottom: 24px;

    @media (max-width: ${LayoutConst.screen.mac13 + 1}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
        font-size: 13px;
        line-height: 16px;
    }

    @media(max-width: ${LayoutConst.screen.s -1}px) {
        font-size: 11px;
        line-height: 13px;
        margin-bottom: 16px;
    }
`;

export const ProtectButton = styled(FlexBox)`
    cursor: pointer;
    font-weight: 600;
    font-family: 'Inter', Sans-serif;
    font-size: 17px;
    line-height: 22px;
    // background-color: ${({ theme }) => theme.projectEdit.protectBlock.paid_block.button.bg};
    // color: ${({ theme }) => theme.projectEdit.protectBlock.paid_block.button.color};
    padding: 12px 30.5px;
    border-radius: 3px;
    white-space: nowrap;
    user-select: none;
    pointer-events: none;
    background-color: #b6b6b5;
    color: #e7e7e7;
    place-items: center;
    justify-content: center;

    div {
        margin: 0;
    }

    span {
        margin-left: 8px;
        margin-right: 2px;
    }

    @media (max-width: ${LayoutConst.screen.mac13 + 1}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
        font-size: 15px;
        line-height: 20px;

        padding: 8px 32px;
    }

    @media(max-width: ${LayoutConst.screen.s -1}px) {
        width: 100%;
        padding-left: 0;
        padding-right: 0;
    }


`;

export const PsProtectInfo: FC<{ project: Project, bookPaymentData: any, limitContentCount?: number, longreadCount?: number, QueueButtonsComponent?: any}> = ({ project, bookPaymentData, limitContentCount, longreadCount, QueueButtonsComponent }) => {
    const { t } = useTranslation();
    const viewType = useMemo(() => (project?.longread?.viewType || DEFAULT_VIEW_TYPE), [project])
    //@ts-ignore
    const isPaidContentOn = useMemo(() => (!!project?.isPaidContent) , [project])

    if (!project || !isPaidContentOn || bookPaymentData?.copyCard) {
        return null;
    }


    return (
        <ProtectWrapper viewType={viewType} longreadCount={longreadCount}>
            <ProtectTitle>
                {t('project_edit.protect_block.paid_block.title')}
            </ProtectTitle>
            <ProtectSubtitle>
                {t('project_edit.protect_block.paid_block.subtitle')}
            </ProtectSubtitle>
            
            {limitContentCount === 0 ? null : QueueButtonsComponent}
        </ProtectWrapper>
    )
}import { Project } from "@brg/api";
import { Colors, FlexBox } from "@brg/ui";
import { FC, useMemo } from "react";
import styled, { css } from "styled-components";
import { DEFAULT_VIEW_TYPE, ProjectBottomActionsWrapper } from "./ps-bottom-actions";
import { LayoutConst } from "core";
import { useTranslation } from "react-i18next";
import { FlorinIcon } from "shared/icons/FlorinIcon/FlorinIcon";
import { ModerationType } from "../../teams/const/ModerationTypes";

export const ProtectWrapper = styled(ProjectBottomActionsWrapper)<{ longreadCount?: number}>`
    text-align: center;
    min-height: 145px;
    max-height: 145px;
    display: flex;
    flex-flow: column;
    margin: 24px auto;
`;

export const ProtectTitle = styled(FlexBox)`
    color: ${Colors.zel};
    font-weight: 600;
    font-family: 'Inter', Sans-serif;
    font-size: 30px;
    line-height: 40px;
    margin-bottom: 12px;

    @media (max-width: ${LayoutConst.screen.mac13 + 1}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
        font-size: 23px;
        line-height: 29px;
    }

    @media(max-width: ${LayoutConst.screen.s -1}px) {
        font-size: 22px;
        line-height: 28px;
    }
`;

export const ProtectSubtitle = styled(FlexBox)`
    color: ${Colors.zel};
    font-weight: 400;
    font-family: 'Inter', Sans-serif;
    font-size: 17px;
    line-height: 22px;

    margin-bottom: 24px;

    @media (max-width: ${LayoutConst.screen.mac13 + 1}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
        font-size: 13px;
        line-height: 16px;
    }

    @media(max-width: ${LayoutConst.screen.s -1}px) {
        font-size: 11px;
        line-height: 13px;
        margin-bottom: 16px;
    }
`;

export const ProtectButton = styled(FlexBox)`
    cursor: pointer;
    font-weight: 600;
    font-family: 'Inter', Sans-serif;
    font-size: 17px;
    line-height: 22px;
    // background-color: ${({ theme }) => theme.projectEdit.protectBlock.paid_block.button.bg};
    // color: ${({ theme }) => theme.projectEdit.protectBlock.paid_block.button.color};
    padding: 12px 30.5px;
    border-radius: 3px;
    white-space: nowrap;
    user-select: none;
    pointer-events: none;
    background-color: #b6b6b5;
    color: #e7e7e7;
    place-items: center;
    justify-content: center;

    div {
        margin: 0;
    }

    span {
        margin-left: 8px;
        margin-right: 2px;
    }

    @media (max-width: ${LayoutConst.screen.mac13 + 1}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
        font-size: 15px;
        line-height: 20px;

        padding: 8px 32px;
    }

    @media(max-width: ${LayoutConst.screen.s -1}px) {
        width: 100%;
        padding-left: 0;
        padding-right: 0;
    }


`;

export const PsProtectInfo: FC<{ project: Project, bookPaymentData: any, limitContentCount?: number, longreadCount?: number, QueueButtonsComponent?: any}> = ({ project, bookPaymentData, limitContentCount, longreadCount, QueueButtonsComponent }) => {
    const { t } = useTranslation();
    const viewType = useMemo(() => (project?.longread?.viewType || DEFAULT_VIEW_TYPE), [project])
    //@ts-ignore
    const isPaidContentOn = useMemo(() => (!!project?.isPaidContent) , [project])

    if (!project || !isPaidContentOn || bookPaymentData?.copyCard) {
        return null;
    }


    return (
        <ProtectWrapper viewType={viewType} longreadCount={longreadCount}>
            <ProtectTitle>
                {t('project_edit.protect_block.paid_block.title')}
            </ProtectTitle>
            <ProtectSubtitle>
                {t('project_edit.protect_block.paid_block.subtitle')}
            </ProtectSubtitle>
            
            {limitContentCount === 0 ? null : QueueButtonsComponent}
        </ProtectWrapper>
    )
}